import { gql } from 'graphql-request';

export const START_AGENTIC_SESSION = gql`
  mutation StartAgenticSession($agenticSessionInput: AgenticSessionInput!) {
    startAgenticSession(agenticSessionInput: $agenticSessionInput) {
      sessionId
    }
  }
`;

export const GET_AGENT_STATUS = gql`
  query GetAgentStatus($sessionId: String!) {
    getAgentStatus(sessionId: $sessionId) {
      status
      result {
        ... on AgentSuccess {
          __typename
          content
          structuredOutput
        }
        ... on AgentError {
          __typename
          message
        }
      }
      timestamp
    }
  }
`;

export const POST_USER_MESSAGE = gql`
  mutation PostUserMessage($sessionId: String!, $message: String!, $isStateUpdated: Boolean, $stateUpdate: JSON) {
    postUserMessage(sessionId: $sessionId, message: $message, isStateUpdated: $isStateUpdated, stateUpdate: $stateUpdate)
  }
`;

export const END_AGENTIC_SESSION = gql`
  mutation EndAgenticSession($sessionId: String!) {
    endAgenticSession(sessionId: $sessionId)
  }
`;

export const EXECUTE_CUSTOM_OPERATION = gql`
  mutation ExecuteCustomOperation($operationInput: OperationInput!) {
    executeCustomOperation(operationInput: $operationInput)
  }
`;

export const GET_FEEDBACK_CATEGORIES = gql`
  query GetFeedbackCategories {
    getFeedbackCategories {
      key
      label
    }
  }
`;

export const SUBMIT_AGENT_FEEDBACK = gql`
  mutation SubmitAgentFeedback($feedbackInput: FeedbackInput!) {
    submitAgentFeedback(feedbackInput: $feedbackInput) {
      success
      loopId
      isUpdate
    }
  }
`;
